import { render, staticRenderFns } from "./QuestionMult2.vue?vue&type=template&id=920d32b4&scoped=true&"
import script from "./QuestionMult2.vue?vue&type=script&lang=js&"
export * from "./QuestionMult2.vue?vue&type=script&lang=js&"
import style0 from "./QuestionMult2.vue?vue&type=style&index=0&id=920d32b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "920d32b4",
  null
  
)

export default component.exports